import { ICON_TYPES } from './iconTypes';

export default {
	calendar: {
		name: 'calendar',
		type: ICON_TYPES.ionicon,
		text: 'Calendar',
	},
	clock: {
		name: 'clock',
		type: ICON_TYPES.fontAwesome5,
		text: 'Clock',
	},
};